module.exports = __webpack_public_path__ + "static/media/noImage.295c4e55.png";